/**
 * Set up additional HTML regions outside of the App Layout
 *      - custom HTML
 *      - analytics
 */
import $ from 'jquery';
import Handlebars from 'handlebars';
import custom_theme_template from '@/../templates/custom-theme.hbs';
import ga_template from '@/../templates/google-analytics.hbs';

    export default function init_html(options) {
        this.options = (options || {});
        /*
        * Compile css theme settings from config file
        * & templates/custom-theme.hbs.
        *
        * Then appended as a style object with jQuery
        * to the document head.
        *
        * If a google analytics account is specified
        * render the ga tracking script into the body
        * of the page and begin tracking. router.js
        * also checks to see if this feature is enabled
        * and sends pageview events
        *
        */
        var data = {};
        if (options.theme) {
            data = options.theme;
        }
        // This is intentionally structured to show signup by default if not overriden
        if (options.features && options.features.signup === false) {
            data.hideSignup = true;
        }

        if (options.features && options.features.ga_account) {
            data.ga_account = options.features.ga_account;
        }

        var style = Handlebars.compile(custom_theme_template);
        var footer = Handlebars.compile(ga_template);
        $('head').append(style(data));
        $('body').append(footer(data));
    }

